/**
 * 📊 XLSX CONTROLLER (Final Unified Version)
 * Location: src/registered/common/parsers/XlsxController.js
 */
import * as XLSX from 'xlsx';
import { TaxonomyReconstructor } from '../../site-admin/components/Workflow-esg/services/taxonomy_reconstructor';

export const XlsxController = {
    execute: async (buffer, onProgress) => {
        try {
            const workbook = XLSX.read(new Uint8Array(buffer), { type: 'array' });

            // 1. Identify Target Sheets (Mapping from Environment)
            const mapping = {
                presentation: process.env.REACT_APP_ESG_PRESENTATION || "PresentationLinkbase",
                definition: process.env.REACT_APP_ESG_DEFINITION || "DefinitionLinkbase",
                calculation: process.env.REACT_APP_ESG_CALCULATION || "CalculationLinkbase"
            };

            const getSheet = (name) => {
                const sheet = workbook.Sheets[name];
                if (!sheet) throw new Error(`Sheet "${name}" not found in Excel file.`);
                const rawRows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
                const colMap = {};
                (rawRows[0] || []).forEach((text, index) => {
                    if (text) colMap[String(text).trim()] = index;
                });
                return { rows: rawRows, colMap };
            };

            // 2. Extract Data Pillars
            const presData = getSheet(mapping.presentation);
            const defData  = getSheet(mapping.definition);
            const calcData = getSheet(mapping.calculation);

            // 🚀 3. THE RELATIONAL JOIN (The Sandbox Logic)
            const result = TaxonomyReconstructor.reconstruct(presData, defData, calcData);

            // 4. Return to DiscoveryFactory
            return { 
                format: 'XLSX_TAXONOMY', 
                esgTree: result.esgTree,
                xbrlRelationships: result.xbrlRelationships,
                worksheets: workbook.SheetNames.map(name => ({
                    name,
                    rowCount: XLSX.utils.sheet_to_json(workbook.Sheets[name]).length,
                    headers: (XLSX.utils.sheet_to_json(workbook.Sheets[name], { header: 1 })[0]) || []
                }))
            };

        } catch (err) {
            console.error("❌ [XLSX_CONTROLLER_ERROR]:", err.message);
            throw err;
        }
    }
};